import { useMemo } from 'react';
import type { CoordinationClientType } from '@atlassiansox/engagekit-ts/controllers/coordination-client';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { getWorkspaceId } from '@confluence/analytics-web-client';
import { useAnalyticsEnvironment } from '@confluence/choreographer-services/entry-points/useAnalyticsEnvironment.ts';

import { getCoordinationClient } from './getCoordinationClient.ts';

export const useCoordinationClient = (withChoreographer = true): CoordinationClientType => {
	const { cloudId, activationId, environment } = useSessionData();

	const workspaceId = getWorkspaceId(cloudId, activationId);

	const disableEngagementForTests =
		sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
	const envType = useAnalyticsEnvironment(environment);

	return useMemo(
		() =>
			getCoordinationClient(
				disableEngagementForTests,
				cloudId,
				workspaceId,
				withChoreographer,
				envType,
			),
		[disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType],
	);
};
